__turbopack_context__.v({
  "wrapper": "ArticleSectionMap-module-scss-module__XMUvWa__wrapper",
});
